/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import {PDFElementParams, PdfFont} from "../../util/interfaces";

let HISTORY: string[] = [];
let currentIdx: number = -1;

export const addToHistory = (items: PDFElementParams<any, any>[], mainFont: PdfFont) => {
    clearFrom(currentIdx);
    const history: string = JSON.stringify({items, mainFont});
    if (history !== HISTORY[currentIdx]) {
        HISTORY.push(history);
        currentIdx++;
    }
};

export const replaceHistory = (items: PDFElementParams<any, any>[], mainFont: PdfFont) => {
    if(currentIdx > -1) {
        HISTORY[currentIdx] = JSON.stringify({items, mainFont});
    }
}

export const undo = (): { items: PDFElementParams<any, any>[], mainFont: PdfFont } => {
    if (currentIdx <= 0) throw new Error('Current index is already at first position.');
    const prevHistory = HISTORY[--currentIdx]
    if (prevHistory)
        return JSON.parse(prevHistory);
    return {items: [], mainFont: PdfFont.LATO};
};

export const redo = (): { items: PDFElementParams<any, any>[], mainFont: PdfFont } => {
    if (currentIdx >= HISTORY.length - 1) throw new Error('Current index is already at the end of HISTORY.');
    const nextHistory = HISTORY[++currentIdx]
    if (nextHistory)
        return JSON.parse(nextHistory);
    return {items: [], mainFont: PdfFont.LATO};
};

export const clearHistory = () => {
    HISTORY = [];
    currentIdx = -1;
}

export const canUndo = (): boolean => currentIdx > 0;
export const canRedo = (): boolean => currentIdx < HISTORY.length - 1;

const clearFrom = (index: number) => {
    const newHistory: string[] = [];
    for (let i = 0; i < HISTORY.length; i++) {
        newHistory.push(HISTORY[i]);
        if (i === index) break;
    }
    HISTORY = newHistory;
};